import React from 'react';
import { AccordionItem } from './AccordionItem';
export const Accordion = ({ children }) => {
    return React.createElement("div", { "data-testid": "Accordion" }, children);
};
Accordion.Item = AccordionItem;
